import React, { useState, useEffect } from "react";
import { updateData, addData } from "../../../lib/sessionschedule";

export default function ScheduleNote({ value, setValue, scheduleId }) {
  const [newAnswer, setNewAnswer] = useState(value ? value : "");
  const [show, setShow] = useState(false);

  //console.log("edit", value, scheduleId, newAnswer);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("Answer", newAnswer);
    setValue(newAnswer);

    await updateData({
      id: scheduleId,
      note: newAnswer,
    });

    if (scheduleId == 0) {
      console.log("Yeni");
      /*
      await addData({
        studentId: studentId,
        questionId: questionId,
        isAnswer: true,
        studentAnswer: newAnswer
      });
      */
    } else {
      //console.log("Eski");
      /*
      await updateData({
        id: scheduleId,
        note: newAnswer
      });
      */
    }
    setShow(true);
  };

  useEffect(() => {
    //console.log("edituseEffect", value, scheduleId);

    setNewAnswer(value);
  }, [value]);

  const messages = () => {
    return (
      <div
        className="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>Data Updated...</strong>{" "}
        {/*You should check in on some of those fields below.*/}
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    );
  };

  return (
    <form method="post" onSubmit={handleSubmit}>
      {show ? messages() : ""}
      <div className="col-12">
        <div className="form-group">
          <label className="form-control-label">Note</label>
          <textarea
            className="form-control"
            value={newAnswer}
            onChange={(e) => setNewAnswer(e.target.value)}
            rows="4"
          ></textarea>
        </div>
      </div>
      <div className="update-profile d-flex justify-content-between">
        <button type="submit" className="btn btn-primary">
          Update
        </button>
      </div>
    </form>
  );
}
